<template>
  <div>
    <page-detail
    :forms="forms"
    :name="name"
    :params="params"
    :parent="parent"
    @action-button="actionButtonHandler"
    >
    </page-detail>
    <representative-file-modal
        v-if="renderFileModal"
        :buttonName="buttonName"
        :params="params"
        @close-modal="closeModal"
        >

        </representative-file-modal>
      </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import RepresentativeFileModal from './RepresentativeFileModal.vue'
const {
  pageDetail
} = JtCrud

  @Component({
    mixins: [pageDetail],
    name: 'crudLayoutDetail',
    components: { pageDetail, RepresentativeFileModal },
    props: {
      name: String,
      forms: { type: Array, required: true },
      params: Object,
      parent: Object
    }
  })
class RepresentativeDetailPage extends Vue {
  buttonName = ''
    renderFileModal = false
    params = {}

    closeModal () {
      this.buttonName = ''
      this.params = {}
      this.renderFileModal = false
    }

    actionButtonHandler (button, params) {
      this.buttonName = button.name
      this.params = params
      this.renderFileModal = true
    }
  }
export default RepresentativeDetailPage
</script>
  <style lang="stylus" scoped>
  </style>
